<template>
<div class="mx-3 py-4 border-top" data-test="orgItemClientSnapshot">

	<div v-if="!data_loaded" class="row" style="min-height:200px;">
		<div class="col-12">
			<img class="center-me" src="/images/loading-color.svg">
		</div>
	</div>

	<template v-else>
		<div class="font-weight-bold text-blue-700 mb-3">Check-ins this Month</div>

		<div v-if="!checkins.length" class="border-bottom pb-4 mb-4 text-nowrap text-center text-gray-500 text-xl">
			No check-ins this month
		</div>

		<div v-else class="d-flex border-bottom pb-4 mb-4 align-items-center">
			<div class="mr-4 checkins-table">
				<div v-for="type in checkinsByType" class="mb-1 text-nowrap">
					<span class="text-lg d-inline-block font-weight-bold" style="min-width:20px;">{{ type.length }}</span>
					<span class="badge text-base" :class="type[0].checkin_type.css_class_name">{{ type[0].checkin_type.label }}</span>
				</div>
			</div>

			<div class="flex-grow-1">
				<bar-chart
				    :chart-data="checkinsEachDay"
				    :options="optionsChart"
				    :height="85"
				/>
			</div>

			<div class="ml-4">
				<div v-for="user in checkinsByUser" class="d-flex align-items-center text-nowrap mb-2">
					<div class="rounded-circle avatar-xs circle-cropped mr-1">
						<img class="img-fluid" :src="user[0].checkin_user.photo_url">
					</div>	
					<span class="flex-grow-1 text-base mr-2">{{ user[0].checkin_user.display_name }}</span>
					<span class="badge text-base bg-primary text-white">{{ user.length }}</span>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6 col-12">
				<div class="font-weight-bold text-blue-700 mb-3">Planned Activities</div>
				<div v-if="!activities.length" class="text-gray-500 text-lg">
					No routes or campaigns
				</div>
				<div v-else v-for="activity in activities" class="d-flex align-items-center mb-3">
					<div class="rounded-circle circle-cropped avatar-sm mr-2 text-center text-sm text-white bg-secondary">
						<i class="fal" :class="activity.route_start_other ? 'fa-route' : 'fa-fire-alt'"></i>
					</div>
					<div>
						<div class="text-gray-700 text-sm leading-tight">
							{{ activity.status_text }} <i v-if="activity.status == 2" class="fad fa-badge-check text-primary"></i>
						</div>
						{{ activity.title }} <span v-if="activity.type_readable" class="badge badge-secondary text-white" >{{ activity.type_readable }}</span>
					</div>
				</div>
			</div>

			<div class="col-md-6 pl-md-4 col-12">
				<div class="font-weight-bold text-blue-700 mb-3">Active Goals</div>
				<div v-if="!goals.filter(goal => goal.status == 1).length" class="text-gray-500 text-lg">
					No active goals
				</div>
				
				<template v-else>
					<goal-item-small v-for="(goal, key) in goals.filter(goal => goal.status == 1)" :goal="goal" :key="key" />
				</template>
			</div>
		</div>
	</template>
</div>
</template>

<script>
	import { mapState } from 'vuex';
  	import BarChart from '../helpers/BarChart.js';
	import GoalItemSmall from '../components/GoalItemSmall';

	export default {
		props: ['client_id'],

		components: {
			BarChart,
			GoalItemSmall,
		},

        data() {
            return {
                data_loaded: false,
                items_loaded: [],

                campaigns: [],
                checkins: [],
                goals: [],
                routes: [],

                checkinsEachDay: {},
                //daysInMonth: [...Array(moment().daysInMonth() + 1).keys()],

	            optionsChart: {
	                height: '85px',
	                responsive: true,                
	                maintainAspectRatio: false,
	                title: {
	                    display: false,
	                },                
	                legend: {
	                    display: false
	                },                 
	                animation: {
	                    duration: 0, // general animation time
	                },                
	                scales: {
	                    xAxes: [{
                            type: 'time',
                            time: {
                            	stepSize: 1,
                                unit: 'day',
                                displayFormats: {
                                    month: 'DD'
                                }
                            },                            
                            distribution: 'linear',

	                    	barPercentage: 0.5,

	                    	gridLines: {
	                    		drawTicks: false,
	                    		//display: false,
	                    		drawOnChartArea: false,
	                    	},                    	
	                        ticks: {
	                            min: moment().startOf('month'),
	                            max: moment().endOf('month'),
	                            display: true,
	                            fontSize: 10,
	                            padding: 6,	                            
				                fontColor: '#A0A3A6',
	                        }
	                    }],
	                    yAxes: [{
	                    	display: false,
				            ticks: {
				                beginAtZero: true,
				            },
	                        gridLines: {
	                            display:false
	                            //drawOnChartArea: false,
	                        }  
	                    }],
	                },

                    tooltips: {
                        callbacks: {
                            title: function(tooltipItem, data) {

                                return moment(tooltipItem[0].label).format('MMM D, YYYY');
                            }
                        }
                    },

	            },                
            }
        },

		created() {
			this.fetchData();
		},

		methods: {
			fetchData() {
				axios.get('/api/admin/checkins/client/' + this.client_id + '?range=mtd').then(({data}) => {
					this.checkins = data;
					this.items_loaded.push('checkins');
					
					var dayGroups = _.countBy(this.checkins, function(checkin) { return moment(checkin.created_at).format('YYYY-MM-DD') });
					this.checkinsEachDay = {
						labels: [],
		                datasets: [{
		                    label: 'Checkins',
		                    data: Object.keys(dayGroups).map(day => ({ t: day, y: dayGroups[day] })),
		                    barPercentage: 0.66,
		                    borderWidth: 0,
		                }] 					
					}
				});
				axios.get('/api/admin/goals/client/' + this.client_id).then(({data}) => {
					this.goals = data;
					this.items_loaded.push('goals');
				});
				axios.get('/api/admin/campaigns/client/' + this.client_id + '?range=mtd').then(({data}) => {
					this.campaigns = data;
					this.items_loaded.push('campaigns');
				});	
				axios.get('/api/admin/routes/client/' + this.client_id + '?range=mtd').then(({data}) => {
					this.routes = data;
					this.items_loaded.push('routes');
				});								
			},
		},

		computed: {
			activities() {
				return [...this.campaigns, ...this.routes];
			},
			checkinsByType() {
				return _.groupBy(this.checkins, 'checkin_type.label');
			},
			checkinsByUser() {
				return _.groupBy(this.checkins, 'user_id');
			},			
		},

		watch: {
			items_loaded() {
				if (this.items_loaded.length == 4) {
					this.data_loaded = true;
				}
			}
		}
	}
</script>